// extracted by mini-css-extract-plugin
export var arrowsContainer = "media-cards-module--arrowsContainer--0f699";
export var capsule = "media-cards-module--capsule--be892";
export var cardsContainer = "media-cards-module--cardsContainer--eaa6e";
export var content = "media-cards-module--content--769c2";
export var filtersColumn = "media-cards-module--filtersColumn--77f7c";
export var header = "media-cards-module--header--d8efc";
export var mediaContainer = "media-cards-module--mediaContainer--0eb23";
export var textIntro = "media-cards-module--textIntro--e1347";
export var title = "media-cards-module--title--9961c";